import React from 'react'
import PropTypes from 'prop-types'
import { StyledForm } from './styles'

const Form = ({ children, onSubmit }) => (
  <StyledForm
    method="post"
    onSubmit={onSubmit}
  >
    {children}
  </StyledForm>
)

export default Form

Form.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
}